const { objectOperator } = require('../utils/spread');
const { AVAILABILITY, CDN_HEALTH } = require('../../constants/initiatives');
const { start: cdnHealthInitiative } = require('./cdn-health');
const { start: availabilityInitiative } = require('./availability');

const start = args => {
  cdnHealthInitiative(objectOperator({ args, id: CDN_HEALTH }));
  availabilityInitiative(objectOperator({ args, id: AVAILABILITY }));
};

module.exports = {
  start,
};
